import { Component, OnInit } from '@angular/core';
import { ExClientsListResource } from 'app/models/ExClientsListResource';
import { ExClientsResource } from 'app/models/ExClientsResource';
import { UserListResource } from 'app/models/UserListResource';
import { UserResource } from 'app/models/UserResource';
import { UtilsService } from 'app/services/utils.service';

@Component({
	selector: 'vbn-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

	clients: UserListResource;
	exClients: ExClientsListResource;
	errorMessage: any;
	selectedUserId: number;
	selectedUser: UserResource;
	selectedExUserId: number;
	selectedExUser: ExClientsResource;
	clientListType = "0";
	roleId = parseInt(localStorage.getItem("_roleId"));
	
	constructor( private service: UtilsService) { 
		this.clients = new UserListResource();
		this.clients.users = []
		this.exClients = new ExClientsListResource();
		this.exClients.list = [];
		this.selectedUser = new UserResource();
		this.selectedExUser = new ExClientsResource();
		this.clientListType = "0";
		this.selectedUserId = 0;
		this.selectedExUserId = 0; 
	}

	ngOnInit() {
		if(this.roleId != 5){
			this.getClientList();
			this.getExClientList();
		}
		
	}

	getClientList(){

		const listType = (this.roleId === 1)?"getAll":"getAllBPO"; //adminul vede toti clientii/ BPO, doar pe cei cu serviciul platit
		this.service.get(`/admin/user/clients/${listType}`)
		.subscribe(
		response => {
		  this.clients = response;
		  let userEmail = this.service.currentUserEmail;
		  if (userEmail){
			  let selectedClient = this.clients.users.filter( x => (x.email === userEmail) );
			  if( selectedClient && selectedClient.length > 0){
				this.selectedUser = selectedClient[0];
				  this.selectedUserId = selectedClient[0].rid;
			  	  this.clientListType = "0";
			  }
		  }
		  if(localStorage.getItem("_sc") && (this.selectedUserId != 0)) {
			this.edit();
		}
	  
		},
		error => this.errorMessage = <any>error);
	}

	getExClientList(){
		this.service.get('/admin/user/exClients/getAll')
		.subscribe(
		response => {
		  console.log("Ex Clients List: ", response)
		  this.exClients = response;
		  let userEmail = this.service.currentUserEmail;
		  if (userEmail){
			  let selectedClient = this.exClients.list.filter( x => (x.email === userEmail) );
			  if( selectedClient && selectedClient.length > 0 ){
				  this.selectedUser = new UserResource();
				  this.selectedExUser = selectedClient[0];
				  this.selectedExUserId = selectedClient[0].rid;
				  this.clientListType = "1";
			  }
		  }
		  if(localStorage.getItem("_sc") && (this.selectedExUserId != 0)) {
			this.edit();
		}
		},
		error => this.errorMessage = <any>error);
	}

	edit(){
		if(this.clientListType === "0"){
			this.selectedUser =  this.clients.users.filter( x => (x.rid === +this.selectedUserId) )[0];
			this.selectedExUser = new ExClientsResource();
			localStorage.setItem("_sc", btoa(this.selectedUser.email));
			this.service.currentUserEmail = this.selectedUser.email;
			this.service.changeAppModuleEnable(this.selectedUser.canUseAppointments);
		}else{
			this.selectedUser =  new UserResource();
			this.selectedExUser = this.exClients.list.filter( x => x.rid === +this.selectedExUserId)[0];
			localStorage.setItem("_sc", btoa(this.selectedExUser.email));
			this.service.currentUserEmail = this.selectedExUser.email;
		}
	}

	reset(){
		localStorage.removeItem("_sc");
		this.service.currentUserEmail = atob(localStorage.getItem("_user"));
		this.selectedExUser = new ExClientsResource();
		this.selectedUser =  new UserResource();
		this.selectedUserId = 0;
		this.selectedExUserId = 0;
	}
}
